import React from 'react';
import SizeMastersContext from './size-masters-context';
import {fetchSizeMasters} from './size-masters-api';

export default function SizeMastersProvider({children}) {
  const state = {
    fetchSizeMasters
  };
  return (
    <SizeMastersContext.Provider value={state}>
      {children}
    </SizeMastersContext.Provider>
  )
};
